import { c as _c } from "react/compiler-runtime";
import { mergeClasses } from '@/utils/style';
import React, { PropsWithChildren } from 'react';
import Link from 'next/link';
import { RenderButtonProps } from './../types';
import { addPrefixToDataParams } from '@/utils/string';
export function Button(t0) {
  const $ = _c(25);
  const {
    analyticsParam,
    align,
    ariaLabel,
    className,
    children,
    busy,
    disabled,
    onClick,
    size: t1,
    testId,
    to,
    type: t2,
    variant,
    leftIcon,
    rightIcon,
    target
  } = t0;
  const size = t1 === undefined ? "default" : t1;
  const type = t2 === undefined ? "button" : t2;
  let t3;
  if ($[0] !== align || $[1] !== className || $[2] !== leftIcon || $[3] !== rightIcon || $[4] !== size || $[5] !== variant) {
    t3 = mergeClasses(variant !== "unstyled" && "border-2 text-center text-sm font-semibold rounded-lg px-6 py-4 w-70 lg:w-70 transition-colors aria-disabled:pointer-events-none aria-busy:pointer-events-none whitespace-nowrap flex items-center justify-center", variant !== "unstyled" && "focus-visible:outline-dotted focus-visible:ring-3 focus-visible:outline-blue-500", variant === "primary" && "bg-green-600 border-green-600 text-white hover:text-white hover:bg-green-700 hover:border-green-700 active:text-white active:bg-green-800 active:border-green-800 aria-disabled:text-white aria-disabled:bg-green-200 aria-disabled:border-green-200 aria-busy:text-white aria-busy:bg-green-200 aria-busy:border-green-200", variant === "secondary" && "bg-transparent border-blue-500 text-blue-500 hover:text-white hover:bg-blue-500 hover:border-blue-500 active:text-white active:bg-blue-700 active:border-blue-700 aria-disabled:text-white aria-disabled:bg-blue-200 aria-disabled:border-blue-200 aria-busy:text-white aria-busy:bg-blue-200 aria-busy:border-blue-200", variant === "secondaryDarkBg" && "bg-transparent border-white text-white hover:bg-white hover:border-white hover:text-blue-500 active:bg-white active:border-white active:text-light-gray-900 aria-disabled:opacity-50 aria-busy:opacity-50", "max-w-full", {
      "w-45": size === "sm"
    }, {
      "lg:w-70": size === "md"
    }, {
      "lg:w-86": size === "lg"
    }, {
      "mx-auto": align === "center"
    }, {
      "ml-auto": align === "right"
    }, {
      "justify-between": leftIcon || rightIcon
    }, className);
    $[0] = align;
    $[1] = className;
    $[2] = leftIcon;
    $[3] = rightIcon;
    $[4] = size;
    $[5] = variant;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const fullClassName = t3;
  let t4;
  if ($[7] !== analyticsParam || $[8] !== testId) {
    t4 = addPrefixToDataParams({
      analyticsParam,
      testId,
      prefix: "btn"
    });
    $[7] = analyticsParam;
    $[8] = testId;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const dataParams = t4;
  let t5;
  if ($[10] !== dataParams || $[11] !== fullClassName) {
    t5 = {
      className: fullClassName,
      ...dataParams
    };
    $[10] = dataParams;
    $[11] = fullClassName;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  const commonProps = t5;
  let t6;
  if ($[13] !== ariaLabel || $[14] !== busy || $[15] !== children || $[16] !== commonProps || $[17] !== disabled || $[18] !== leftIcon || $[19] !== onClick || $[20] !== rightIcon || $[21] !== target || $[22] !== to || $[23] !== type) {
    t6 = to ? <Link {...commonProps} href={to} title={ariaLabel} target={target}>{leftIcon && <span className="mr-2">{leftIcon}</span>}{children}{rightIcon && <span className="ml-2">{rightIcon}</span>}</Link> : <button {...commonProps} {...disabled && {
      "aria-disabled": true
    }} {...busy && {
      "aria-busy": true
    }} aria-label={ariaLabel} onClick={onClick} type={type}>{leftIcon && <span className="mr-2">{leftIcon}</span>}{children}{rightIcon && <span className="ml-2">{rightIcon}</span>}</button>;
    $[13] = ariaLabel;
    $[14] = busy;
    $[15] = children;
    $[16] = commonProps;
    $[17] = disabled;
    $[18] = leftIcon;
    $[19] = onClick;
    $[20] = rightIcon;
    $[21] = target;
    $[22] = to;
    $[23] = type;
    $[24] = t6;
  } else {
    t6 = $[24];
  }
  return t6;
}